<template>
    <div>

        <v-form v-model="valid" ref="formData">

            <v-dialog v-model="dialogPayment" persistent width="50%">
                <v-overlay :value="overlay">
                    <v-progress-circular
                        indeterminate
                        size="64"
                    ></v-progress-circular>
                </v-overlay>

                <v-card>
                    <v-card-title>
                        <span>{{ $t("payment") }}</span>
                        <v-spacer></v-spacer>
                        <v-btn
                            fab
                            text
                            icon
                            @click="handleClose"
                            valid="false"
                            v-shortkey="['esc']"
                            @shortkey.native="handleClose"
                        >
                            <v-icon dark>mdi-close</v-icon>
                        </v-btn>
                    </v-card-title>

                    <v-card-text>
                        <v-row>
                            <v-col cols="12" sm="6" md="6" class="seperate-line-verticle">

                                <v-row style="padding-right: 10px">

                                    <v-col cols="12" sm="12" md="12" v-if="isOperator">
                                        <v-autocomplete
                                        v-model="formPayment.client_id"
                                            :items="listMillerAndExporter"
                                            outlined
                                            :dense="dense"
                                            auto-select-first
                                            item-text="full_name"
                                            item-value="contact_id"
                                            :label="$t('client') + '*'"
                                            :rules="selectRules"
                                            required
                                            disabled
                                        >
                                        </v-autocomplete>
                                    </v-col>

                                    <v-col cols="12" sm="12" md="12" v-if="isMiller || isExporter || isOperator">
                                        <v-autocomplete
                                        v-model="formPayment.supplier_id"
                                                :items="listCropTrader"
                                                outlined
                                                :dense="dense"
                                                auto-select-first
                                                item-text="full_name"
                                                item-value="crop_id"
                                                :label="$t('supplier') + '*'"
                                                :rules="selectRules"
                                                required
                                                disabled
                                        ></v-autocomplete>
                                    </v-col>

                                    <v-col cols="12" sm="12" md="12">
                                        <v-select
                                            v-model="formPayment.currency_code"
                                            :items="currencyOptionList"
                                            disabled
                                            :label="$t('currency')"
                                            outlined
                                            item-text="text"
                                            item-value="id"
                                            dense
                                        ></v-select>
                                    </v-col>

                                     <v-col cols="12" sm="12" md="12">
                                        <v-select
                                            :items="paymentMethod"
                                            :label="$t('paymentMethod')"
                                            outlined
                                            v-model="formPayment.payment_method"
                                            dense
                                            disabled
                                        >
                                            <template v-slot:selection="{ item }">{{ $t(item) }}</template>
                                            <template v-slot:item="{ item }">{{ $t(item) }}</template>
                                        </v-select>
                                    </v-col>

                                    <v-col cols="12" sm="12" md="12" v-if="formPayment.payment_method == 'wallet'">
                                        <v-select
                                            :items="customerWallet"
                                            :label="$t('wallet') + '*'"
                                            outlined
                                            v-model="formPayment.wallet_account"
                                            :rules="selectRules"
                                            item-text="account_type_name"
                                            item-value="account_type_name"
                                            dense
                                        >
                                            <template v-slot:selection="{item}">
                                                {{$t(item.account_type_name) }} : {{ item.available_balance |
                                                formatNumber}} {{currency_symbol}}
                                            </template>
                                            <template v-slot:item="{item}">
                                                {{ $t(item.account_type_name) }} : {{ item.available_balance |
                                                formatNumber}} {{currency_symbol}}
                                            </template>
                                        </v-select>
                                    </v-col>

                                    <v-col cols="12" sm="12" md="12">
                                        <v-menu
                                            v-model="menuDate"
                                            :close-on-content-click="false"
                                            :nudge-right="40"
                                            transition="scale-transition"
                                            offset-y
                                            min-width="290px"
                                        >
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-text-field
                                                    v-model="formPayment.date"
                                                    :label="$t('receivePaymentDate') + '*'"
                                                    prepend-inner-icon="mdi-calendar"
                                                    outlined
                                                    dense
                                                    readonly
                                                    :rules="dateRules"
                                                    v-bind="attrs"
                                                    v-on="on"
                                                ></v-text-field>
                                            </template>
                                            <v-date-picker
                                                :first-day-of-week="0"
                                                v-model="formPayment.date"
                                                :rules="dateRules"
                                                @input="menuDate = false"
                                            ></v-date-picker>
                                        </v-menu>
                                    </v-col>

                                    <v-col cols="12" sm="12" md="12">
                                        <v-text-field
                                            v-model="formPayment.reference"
                                            outlined
                                            dense
                                            :label="$t('reference')"
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                            </v-col>

                            <v-col cols="12" sm="6" md="6">
                                <v-row>
                                    <!-- <v-col cols="5" sm="5">{{ $t("step") }}</v-col>
                                    <v-col cols="7" sm="7"> : <span style="font-weight: bold;font-size: 20px">{{ formPayment.step}}</span></v-col>
                                    <v-col cols="5" sm="5">{{ $t("duration") }}</v-col>
                                    <v-col cols="7" sm="7"> : <span style="font-weight: bold;font-size: 20px">{{ formPayment.duration }} {{ $t(formPayment.duration_type.split("_")[1])}}</span></v-col> -->

                                    <v-col cols="5" sm="5">{{ $t("totalAmount") }}</v-col>
                                    <v-col cols="7" sm="7"> : <span style="font-weight: bold;font-size: 20px">{{ +formPayment.total_amount | formatNumber}} {{getCurrencySymbol(formPayment.currency_code)}}</span></v-col>
                                    <v-col cols="5" sm="5">{{ $t("paid") }}</v-col>
                                    <v-col cols="7" sm="7"> : <span style="font-weight: bold;font-size: 20px">{{ +formPayment.complete_paid | formatNumber }} {{getCurrencySymbol(formPayment.currency_code)}}</span></v-col>
                                    <v-col cols="5" sm="5">{{ $t("partial") }}</v-col>
                                    <v-col cols="7" sm="7"> : <span style="font-weight: bold;font-size: 20px">{{ +formPayment.total_payment | formatNumber }} {{getCurrencySymbol(formPayment.currency_code)}}</span></v-col>
                                    <v-col cols="5" sm="5">{{ $t("percentage") }}</v-col>
                                    <v-col cols="7" sm="7"> : <span style="font-weight: bold;font-size: 20px">{{ calculatePercentage }}%</span></v-col>
                                    <v-col cols="5" sm="5">{{ $t("paidAmount") }}</v-col>
                                    <v-col cols="7" sm="7">
                                        <v-text-field
                                            v-model="formPayment.amount_to_pay"
                                            outlined
                                            dense
                                            min="1"
                                            style="margin-bottom: -10px"
                                            :rules="numberRules"
                                        >
                                        </v-text-field>
                                        <span v-show="! valid_paid" class="error--text">{{ $t('maximum') + ' ' + formPayment.total_payment }} </span>
                                    </v-col>

                                    <v-col cols="5" sm="5">{{ $t("bankCharge") }}</v-col>
                                    <v-col cols="7" sm="7">
                                        <v-text-field
                                            v-model="formPayment.bank_charge"
                                            outlined
                                            dense
                                            style="margin-bottom: -10px"
                                            :rules="numberRules"
                                            >
                                        </v-text-field>
                                    </v-col>

                                    <v-col cols="5" sm="5">{{ $t("waveEndingBalance") }}</v-col>
                                    <v-col cols="7" sm="7">
                                        <v-text-field
                                            v-model="formPayment.wave_ending_balance"
                                            outlined
                                            dense
                                            style="margin-bottom: -10px"
                                            :rules="numberRules"
                                            >
                                        </v-text-field>
                                    </v-col>

                                    <v-col cols="5" sm="5">{{ $t("totalPayment") }}</v-col>
                                    <v-col cols="7" sm="7">
                                        <v-text-field
                                            v-model="paidAmount"
                                            outlined
                                            dense
                                            min="1"
                                            style="margin-bottom: -10px"
                                            disabled
                                            >
                                        </v-text-field>
                                    </v-col>

                                    <v-col cols="12" sm="12" md="12">
                                        <v-textarea
                                            clearable
                                            outlined
                                            :placeholder="$t('yourDesc')"
                                            v-model="formPayment.note"
                                            clear-icon="mdi-close-circle"
                                            rows="3"
                                            auto-grow
                                            :label="$t('note')"
                                        ></v-textarea>
                                    </v-col>

                                    <v-col cols="12" sm="12" md="12" v-if="formPayment.paid_status == 'due' && isOperator">
                                        <v-select
                                            :items="paymentSettleFee"
                                            :label="$t('paymentSettleFee')"
                                            item-text="label"
                                            item-value="value"
                                            outlined
                                            :rules="selectRules"
                                            v-model="formPayment.settle_fee"
                                            dense
                                            :disabled="formPayment.payment_method == 'cash' ? true : false"
                                        >
                                            <template v-slot:selection="{ item }">{{ $t(item.label) }}</template>
                                            <template v-slot:item="{ item }">{{ $t(item.label) }}</template>
                                        </v-select>
                                    </v-col>

                                    <v-col cols="12" sm="12" md="12" v-if="formPayment.paid_status == 'due' && isOperator">
                                       <v-text-field
                                            v-model="totalFees"
                                            outlined
                                            dense
                                            :label="$t('totalFee')"
                                            disabled
                                            :suffix="getCurrencySymbol(formPayment.currency_code)"
                                        ></v-text-field>
                                    </v-col>

                                </v-row>
                            </v-col>
                        </v-row>
                    </v-card-text>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                            rounded
                            @click="submitPayment($event,true)"
                            style="min-width: 150px"
                            color="primary"
                            :disabled="! valid_paid"
                        >
                            <font-awesome-icon
                                icon="check-circle"
                                style="margin-right: 10px"
                            />
                            {{$t("payAndPrint")}}
                        </v-btn>
                        <v-btn
                            rounded
                            @click="submitPayment($event)"
                            style="min-width: 150px"
                            color="success"
                            :disabled="! valid_paid"
                        >
                            <font-awesome-icon
                                icon="check-circle"
                                style="margin-right: 10px"
                            />
                            {{$t("proceedPay")}}

                        </v-btn>
                    </v-card-actions>
                </v-card>

            </v-dialog>

        </v-form>

    </div>
</template>
<script>

    import OptionDataMixin from "../../../mixins/optionDataMixin";
    import MainMixin from "../../../mixins/mainMixin";
    import ValidatorMixin from "../../../mixins/validatorMixin";
    import {provider} from "@/service/provider";
    import axios from "axios";
    import moment from "moment";


    export default {
        name: "buybackPayment",
        mixins: [OptionDataMixin, MainMixin, ValidatorMixin],
        data() {
            return {
                currency_symbol: "",
                valid_paid: true,
                paidAmount: 0,
                totalFees: 0,

                formPayment: {
                    id: '',
                    reference: "",
                    client_id: "",
                    supplier_id: "",
                    currency_code: "",
                    note: '',
                    date: moment().format("YYYY-MM-DD"),
                    total_payment: "",
                    complete_paid: "",
                    total_amount: 0,
                    amount_to_pay: 0,
                    paid_amount: 0,
                    bank_charge: 0,
                    wave_ending_balance: 0,
                    payment_type: '',
                    client_name: "",
                    client_phone: "",
                    client_card_type: 'id_card',
                    client_card_number: '',
                    client_photo: [],
                    wallet_account: "",
                    transaction_id: "",
                    transaction_payment_term_id: "",
                    step: "1",
                    percentage: "100",
                    duration: "0",
                    duration_type: '',
                    payment_method: '',
                    settle_fee: '1',
                    total_fees: '',
                    paid_status: '',
                },

            };
        },

        methods: {
            
            reset() {
                if(this.$refs.formData){
                    this.$refs.formData.reset();
                    this.formPayment.date = '';
                    this.formPayment.paid_amount = 0;
                    this.formPayment.amount_to_pay = 0;
                    this.formPayment.bank_charge = 0;
                    this.formPayment.wave_ending_balance = 0;
                    this.formPayment.total_payment= 0;
                    this.formPayment.complete_paid = 0;
                    this.formPayment.total_amount= 0;
                }
                this.paidAmount = 0;
                this.totalFees = 0;
            },

            handleClose(){
                this.$store.dispatch('updateBuybackDialogPayment', {dialog: false, transaction_id: '', client_id: ''});
            },

            submitPayment(event, isPrint) {
                let vm = this;
                event.preventDefault();
                if (vm.$refs.formData.validate()) {

                    if((+this.formPayment.amount_to_pay + +this.formPayment.bank_charge + +this.formPayment.wave_ending_balance) > 0){
                   
                        vm.overlay = true;
                        let url = provider.baseURL + provider.storeCropPayment;
                        return new Promise((resolve, reject) => {
                            axios.post(url, this.formPayment, {headers: {Authorization: localStorage.token}}).then(
                                res => {
                                    if (res.data.response && res.data.response.code === 200) {
                                        resolve(res.data.data.payment_transaction_id);
                                        vm.$notify({
                                            title: "Success",
                                            message: vm.$t("success"),
                                            type: "success",
                                            duration: 700
                                        });
                                        vm.dialog = false;
                                        if (isPrint === true) {
                                            vm.$router.push({name: 'beeshop.buyback.buyback-facilitate.buyback-print', params: { id: vm.formPayment.transaction_id}})
                                        }
                                        vm.overlay = false;
                                        vm.$store.dispatch('updateBuybackDialogPayment', {dialog: false, transaction_id: '', client_id: ''});
                                    }
                                    else{
                                        vm.$notify({
                                            title: "Error",
                                            message: res.data.response.message,
                                            type: "error",
                                            duration: 2000
                                        });
                                        vm.overlay = false;
                                    }
                                },
                                error => {
                                    reject(error);
                                    vm.overlay = false;

                                }

                            );
                        });

                    }else{
                        vm.$notify({
                            title: "Error",
                            message: vm.$t('paidAmount') + ', ' + vm.$t('bankCharge') + ', ' +  vm.$t('waveEndingBalance') + vm.$t('atlease') + " 1",
                            type: "error",
                            duration: 2000
                        });
                        vm.overlay = false;
                    }

                }
            },

            calculatePaidAmount(){
                this.formPayment.paid_amount = +this.formPayment.amount_to_pay - +this.formPayment.bank_charge - +this.formPayment.wave_ending_balance;
            }

        },

        watch: {
            dialogPayment(val) {
                if (val === false) { this.reset(); }
                else {
                    if(this.isOperator){ 
                        // this.fetchListMiller();
                        this.fetchListMillerAndExporter();
                    }
                    this.fetchListCropTrader();
                    this.fetchCurrencyOption();

                    
                }
            },

            async transaction_id(transaction_id){
                if(transaction_id && this.dialogPayment){
                    /** Fetch the payment terms */
                    let vm = this;
                    this.formPayment.date = moment().format("YYYY-MM-DD");
                    this.overlay = true;
                    this.formPayment.total_fees = 0;
                    this.formPayment.paid_amount = 0;
                    let params = {
                        search: '',
                        transaction_id: transaction_id,
                        contact_id: this.$store.state.buyback.client_id,
                        type_order: 'purchase_order',
                        due_date: '',
                        offset: 0,
                        limit: 1
                    }

                    let url = provider.baseURL + provider.fetchListCropPendingPayment;

                    await axios.post(url, params, {headers: {Authorization: localStorage.token}}).then(res => {
                        if (res.data.response && res.data.response.code === 200) {
                            let data = res.data.data[0];
                            vm.formPayment.client_id           = data.client_id;
                            vm.formPayment.supplier_id         = data.supplier_id;
                            vm.formPayment.client_account_no   = data.client_account_no;
                            vm.formPayment.currency_code       = data.currency_code;
                            vm.formPayment.total_payment       = data.total_payment;
                            vm.formPayment.amount_to_pay       = data.total_payment;
                            vm.formPayment.total_amount        = data.total_amount;
                            vm.formPayment.bank_charge         = 0;
                            vm.formPayment.wave_ending_balance = 0;
                            vm.formPayment.complete_paid       = data.complete_paid;
                            vm.formPayment.payment_type        = data.payment_method;
                            vm.formPayment.client_name         = data.client;
                            vm.formPayment.client_phone        = data.client_phone;
                            vm.formPayment.transaction_id      = data.transaction_id;
                            vm.formPayment.transaction_payment_term_id = data.transaction_payment_term_id;
                            vm.formPayment.duration_type       = data.duration_type;
                            vm.formPayment.payment_method      = data.payment_method;
                            vm.formPayment.settle_fee          = data.payment_method == 'cash' ? '0' : '1';
                            vm.formPayment.total_fees          = data.total_fees;
                            vm.formPayment.paid_status         = data.paid_status;
                            vm.overlay = false;
                        }   
                    }).catch(error => {
                        vm.overlay = false;
                        console.log(error)
                    });

                    /** Fethc the waller account */
                    await this.fetchWalletByCustomer(this.formPayment.client_account_no, this.formPayment.currency_code);
                }
            },

            "formPayment.amount_to_pay"(val){
                this.calculatePaidAmount();

                let amount_to_pay = +val;
                let total_amount = +this.formPayment.total_payment;
                if(amount_to_pay > total_amount){
                    this.valid_paid = false;
                }
                else{
                    this.valid_paid = true;
                }
            },
            "formPayment.bank_charge"(){
                this.calculatePaidAmount();
            },
            "formPayment.wave_ending_balance"(){
                this.calculatePaidAmount();
            },

            "formPayment.paid_amount"(){
                this.paidAmount = this.formatNumber(this.formPayment.paid_amount);
            },
            "formPayment.total_fees"(){
                this.totalFees = this.formatNumber(this.formPayment.total_fees);
            }
        },
        computed: {
            calculatePercentage(){
                let per = (+this.formPayment.total_amount - +this.formPayment.complete_paid) / (+this.formPayment.total_amount / 100);
                if(! per){ per = 0; }
                return per.toFixed(2);
            },
            dialogPayment(){
                return this.$store.state.buyback.dialog;
            },  

            transaction_id(){
                return this.$store.state.buyback.transaction_id;
            },
        },
    };
</script>
